module.exports = __webpack_public_path__ + "assets/img/3fc0078bc78b477de53358f4d2a1254e.png";